import { SearchIllustrationIcon } from 'components/common/SearchEmptyIcon/components';
import { Spin } from 'antd';
import useTranslation from 'hooks/use-translation';

export default function SearchEmptyIcon(): JSX.Element {
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  if (translation.common.icons.searchEmpty) {
    return (
      <img
        src={`./config/icons/${translation.common.icons.searchEmpty.src}`}
        alt={translation.common.icons.searchEmpty.alt}
        width={80}
        height={80}
      />
    );
  }

  return <SearchIllustrationIcon />;
}
